// Mirrors backend models/user.py's UserRole - the single reusable
// source of truth for role values on the frontend, so no component
// compares against the raw string "admin" directly.
export const USER_ROLES = Object.freeze({
  USER: 'user',
  ADMIN: 'admin',
});
